export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "1",
    slug: "home-security-guide-2026",
    title: "2026年家庭安防系统选购终极指南",
    excerpt: "面对市场上琳琅满目的安防产品，如何选择最适合自己家庭的安防系统？本文从预算、需求、技术三个维度为您全面解析。",
    content: `<p>随着智能家居技术的快速发展，家庭安防系统已经从简单的防盗门、防盗窗，进化到了智能化、网络化的全屋安防生态。但在琳琅满目的产品和方案面前，很多消费者感到无从下手。本文将从多个维度为您提供专业的选购建议。</p>
    <h2>一、明确你的核心需求</h2>
    <p>在选购安防系统之前，首先要明确自己最关心的是什么。是防盗安全？是防火防灾？还是对老人小孩的监护？不同需求对应的设备方案差异很大。</p>
    <p>对于有老人和孩子的家庭，建议优先配置紧急呼叫按钮和跌倒检测传感器；对于独居女性，智能门磁和随身报警器是必备项；对于经常出差的人群，远程视频监控和智能门锁的组合会让你在外也能随时掌握家中情况。</p>
    <h2>二、预算规划要合理</h2>
    <p>一套基础的家庭安防系统，包括智能门锁、门磁传感器、红外探测器、监控摄像头和报警主机，预算大约在3000-8000元之间。如果需要更全面的覆盖，比如加入烟雾报警器、水浸传感器、智能窗帘等，预算可能需要提升到1-2万元。</p>
    <p>安大师提供从入门到高端的多种套餐选择，您可以根据自己的预算和需求灵活组合。我们的安全顾问会免费上门评估，为您推荐最具性价比的方案。</p>
    <h2>三、重视系统兼容性与扩展性</h2>
    <p>选择安防系统时，系统的兼容性和扩展性至关重要。一个好的安防生态应该能够无缝连接各种品牌的设备，同时支持未来的功能升级。安大师采用开放式协议架构，支持市面上主流的智能家居设备接入，您的系统不会被锁定在单一品牌中。</p>
    <h2>四、售后服务不容忽视</h2>
    <p>安防系统不是一次性消费品，后续的维护、升级和应急响应同样重要。选择有完善售后服务体系的品牌，能够在设备故障或安全事件发生时，得到及时有效的支持。安大师提供7×24小时全天候响应服务，工程师最快2小时上门，确保您的安全不中断。</p>`,
    category: "family",
    categoryName: "家庭安全",
    author: "安大师安全顾问团队",
    date: "2026-07-28",
    readTime: "8分钟",
    imageSeq: "article-home-guide",
    tags: ["家庭安防", "选购指南", "智能家居"],
  },
  {
    id: "2",
    slug: "business-security-risk-assessment",
    title: "企业安全风险评估：99%的管理者都忽略的盲区",
    excerpt: "企业安全不仅仅是防盗和消防，数据安全、供应链安全和员工安全意识培训同样关键。来看看您的企业是否存在这些安全盲区。",
    content: `<p>在走访了超过500家企业后，安大师安全顾问团队发现了一个令人惊讶的事实：绝大多数企业的安全管理存在严重盲区。这些盲区往往不是技术问题，而是认知问题。</p>
    <h2>盲区一：数据安全被严重低估</h2>
    <p>很多中小企业管理者认为，数据安全是大企业才需要关心的事情。事实恰恰相反，中小企业由于防护能力薄弱，反而更容易成为网络攻击的目标。据安大师统计，过去一年中，中小企业的数据泄露事件同比增长了67%。</p>
    <p>建议企业至少做到：核心数据加密存储、员工访问权限分级管理、定期数据备份、安装企业级防火墙。安大师提供的企业数据安全方案，能够在不大幅增加成本的前提下，显著提升数据防护水平。</p>
    <h2>盲区二：供应链安全链条断裂</h2>
    <p>您的供应商、合作伙伴的安全状况，直接影响您的企业安全。一次典型的供应链攻击，往往是从最薄弱的环节突破。安大师建议企业建立供应商安全评估机制，定期审核合作伙伴的安全资质。</p>
    <h2>盲区三：员工安全意识培训缺失</h2>
    <p>数据表明，超过80%的企业安全事件与人为因素有关。员工随意点击钓鱼邮件、使用弱密码、将工作设备带离安全环境……这些看似不起眼的行为，往往是重大安全事件的导火索。安大师提供专业的企业安全培训课程，帮助您的员工建立正确的安全意识和行为习惯。</p>
    <h2>盲区四：应急预案形同虚设</h2>
    <p>很多企业的安全应急预案只是应付检查的"纸上文章"，从未真正演练过。一旦发生真实的安全事件，员工不知所措，延误最佳处置时机。安大师建议企业每季度至少进行一次安全演练，并持续优化应急预案。</p>`,
    category: "business",
    categoryName: "企业防护",
    author: "安大师企业安全事业部",
    date: "2026-07-25",
    readTime: "10分钟",
    imageSeq: "article-business-risk",
    tags: ["企业安全", "风险评估", "数据安全"],
  },
  {
    id: "3",
    slug: "personal-safety-essentials",
    title: "独居女性必备的7件个人安全装备",
    excerpt: "独自生活，安全第一。安大师精选7件实用个人安全装备，从智能报警器到防身工具，全方位守护您的安全。",
    content: `<p>随着城市化进程加速，越来越多的年轻人选择独居生活。对于独居女性而言，个人安全是一个无法回避的话题。安大师结合多年安防经验，为您推荐7件真正实用的个人安全装备。</p>
    <h2>1. 随身智能报警器</h2>
    <p>这是安大师最推荐的个人安全装备。小巧便携，可挂在钥匙扣或包包上。遇到危险时，一键触发高分贝报警声（可达130分贝），同时自动向预设的紧急联系人发送定位信息。内置电池续航长达6个月。</p>
    <h2>2. 智能门磁传感器</h2>
    <p>安装在入户门上，当门被异常打开时立即向您手机推送警报。配合安大师App使用，还可以查看开关门记录，了解家人或室友的出入情况。安装简单，无需布线，这个小设备能极大提升居家安全感。</p>
    <h2>3. 可视化门铃</h2>
    <p>告别盲目开门。可视化门铃让您通过手机就能看到门外是谁，支持远程双向通话。对于独居女性来说，这是避免陌生人上门风险的第一道防线。安大师推荐选择带有AI人形检测和夜视功能的型号。</p>
    <h2>4. 多功能防身手电筒</h2>
    <p>集照明、爆闪、破窗、切割安全带于一体的多功能工具。高亮爆闪模式可让歹徒暂时失明，为您争取宝贵的逃生时间。夜间行走或驾车时的必备之物。</p>
    <h2>5. 定位共享手表</h2>
    <p>当您深夜打车或独自前往陌生地点时，实时定位共享功能让亲友随时掌握您的行踪。安大师推荐选择支持一键SOS求救的型号，电池续航至少24小时。</p>
    <h2>6. 门窗加固器</h2>
    <p>对于出租屋住户来说，更换整套门窗不现实，但可以加装便携式门窗加固器。这种小巧的装置能大幅提升门窗的防撬能力，安装和拆除都很方便，搬家时可以带走。</p>
    <h2>7. 防狼喷雾（合规型）</h2>
    <p>请确保购买符合当地法规的合规产品。建议选择射程远、附着力强的喷雾型，并提前了解使用方法和注意事项。随身携带时放在方便取出的位置，关键时刻每一秒都至关重要。</p>`,
    category: "personal",
    categoryName: "个人保障",
    author: "安大师个人安全事业部",
    date: "2026-07-22",
    readTime: "7分钟",
    imageSeq: "article-personal-safety",
    tags: ["个人安全", "独居女性", "安全装备"],
  },
  {
    id: "4",
    slug: "smart-home-security-trends",
    title: "智能家居安防的五大趋势：AI正在改变家庭安全",
    excerpt: "人工智能、物联网、5G技术的融合正在重新定义家庭安防。了解2026年最值得关注的智能安防技术趋势。",
    content: `<p>2026年，人工智能与物联网技术的深度融合，正在让家庭安防从被动的"事后追溯"向主动的"事前预防"转变。以下是安大师整理的五大技术趋势。</p>
    <h2>趋势一：AI行为分析</h2>
    <p>传统的监控摄像头只能记录画面，需要人工回看才能发现问题。新一代AI摄像头能够实时分析画面中的行为，自动识别可疑活动。例如，当有人在您的门口长时间徘徊，系统会自动标记并向您发送预警通知。</p>
    <h2>趋势二：多设备智能联动</h2>
    <p>单一设备的能力有限，但当门磁、摄像头、烟雾报警器、智能灯光等设备实现智能联动时，能够产生1+1>2的效果。例如，当烟雾报警器触发时，系统自动打开所有灯光、解锁门锁、并拨打紧急电话。</p>
    <h2>趋势三：本地AI边缘计算</h2>
    <p>隐私保护是智能安防的重要议题。新一代安防设备采用本地AI处理，人脸识别、行为分析等敏感计算都在设备本地完成，无需将视频上传到云端，从根本上保护用户隐私。</p>
    <h2>趋势四：5G超低延迟响应</h2>
    <p>5G网络的普及让安防系统的响应速度从秒级提升到毫秒级。报警触发后，系统可以在0.1秒内完成拍照、推送通知、联系应急服务的全流程，这在紧急情况下可能意味着生死之差。</p>
    <h2>趋势五：订阅制安全服务</h2>
    <p>越来越多的家庭选择按月付费的安全托管服务，而不是一次性购买设备。这种模式让用户可以以更低的初始成本享受到专业级的安防服务，同时设备维护、系统升级都由服务商负责，省心省力。安大师的安全托管计划就是基于这一理念设计的。</p>`,
    category: "family",
    categoryName: "家庭安全",
    author: "安大师技术研发中心",
    date: "2026-07-18",
    readTime: "6分钟",
    imageSeq: "article-smart-trends",
    tags: ["智能家居", "AI技术", "家庭安防趋势"],
  },
  {
    id: "5",
    slug: "office-fire-safety-guide",
    title: "办公室消防安全全攻略：从隐患排查到应急演练",
    excerpt: "办公室消防安全往往被忽视，但一旦发生火灾后果不堪设想。安大师为您整理了一份完整的办公场所消防安全指南。",
    content: `<p>办公室是人员密集场所，消防安全管理责任重大。然而在实际走访中，安大师发现很多企业的消防设施形同虚设，员工甚至不知道灭火器放在哪里。这份指南将帮助您系统性地排查和改善办公室消防安全。</p>
    <h2>一、常见火灾隐患清单</h2>
    <p>办公场所最常见的火灾隐患包括：电器线路老化或超负荷使用、大功率电器无人看管、消防通道被堵塞、易燃物品随意堆放、员工在禁烟区吸烟等。建议企业安全负责人每月进行一次全面隐患排查。</p>
    <h2>二、消防设施配置标准</h2>
    <p>根据国家标准，办公场所每50平方米至少配置1具灭火器，疏散通道必须保持畅通无阻，应急照明和疏散指示标志必须完好有效。安大师提供专业的消防设施配置评估服务，帮助您达到甚至超越国家标准。</p>
    <h2>三、员工消防培训要点</h2>
    <p>每位员工都应该掌握的四个基本技能：会使用灭火器、会报火警、会组织疏散、会扑救初起火灾。安大师企业培训团队提供定制化的消防培训课程，结合实操演练，让您的员工真正掌握这些生命攸关的技能。</p>
    <h2>四、应急预案与演练</h2>
    <p>一份好的消防应急预案包括：明确的疏散路线和集合点、各楼层疏散引导员分工、特殊人群（孕妇、残障人士）的协助方案、与物业和消防部门的联动机制。建议每半年至少组织一次全员消防演练。</p>`,
    category: "business",
    categoryName: "企业防护",
    author: "安大师消防安全事业部",
    date: "2026-07-15",
    readTime: "7分钟",
    imageSeq: "article-fire-safety",
    tags: ["消防安全", "办公室安全", "应急演练"],
  },
  {
    id: "6",
    slug: "night-walk-safety-tips",
    title: "夜间出行安全指南：10个必须养成的好习惯",
    excerpt: "无论是加班晚归还是夜间锻炼，夜间出行的安全风险不容忽视。安大师总结10条实用安全建议，助您平安回家。",
    content: `<p>夜间出行，由于光线不足、人流稀少等因素，安全风险要明显高于白天。安大师结合城市安全大数据分析，为您总结了10条夜间出行的安全守则。</p>
    <h2>出行前准备</h2>
    <p>1. 提前规划路线：尽量选择照明良好、人流量大的主干道，避开偏僻小巷。</p>
    <p>2. 告知行踪：将预计到达时间告知家人或朋友，开启实时位置共享。</p>
    <p>3. 充满手机电量：确保手机电量充足，随身携带充电宝。</p>
    <h2>路途中注意事项</h2>
    <p>4. 保持警觉：不要边走边看手机或戴耳机，保持对周围环境的感知。</p>
    <p>5. 注意可疑人员：如发现有人跟踪，立即走向人多的地方或进入附近的便利店、餐厅。</p>
    <p>6. 选择安全交通方式：优先选择正规网约车或出租车，避免搭乘黑车。上车前核实车牌号，将行程分享给亲友。</p>
    <p>7. 随身携带报警器：安大师随身报警器，一键触发130分贝蜂鸣声，有效震慑不法分子。</p>
    <h2>到达后的安全确认</h2>
    <p>8. 开门前观察周围：确保楼道或门前没有可疑人员后再开门。</p>
    <p>9. 养成锁门好习惯：进入房间后立即反锁，不要因为是短暂停留就疏忽大意。</p>
    <p>10. 报平安：到达后向等待的亲友发送确认消息，这是对自己也是对关心您的人负责。</p>`,
    category: "personal",
    categoryName: "个人保障",
    author: "安大师安全研究院",
    date: "2026-07-10",
    readTime: "5分钟",
    imageSeq: "article-night-safety",
    tags: ["夜间安全", "个人防护", "安全习惯"],
  },
];

export const categories = [
  {
    id: "family",
    name: "家庭安全",
    slug: "family",
    description: "守护每一个温馨的家，从智能安防到居家防护，为家人筑起安全堡垒",
    icon: "ri-home-gear-line",
  },
  {
    id: "business",
    name: "企业防护",
    slug: "business",
    description: "全方位企业安全解决方案，守护资产、数据与员工，为企业发展保驾护航",
    icon: "ri-building-2-line",
  },
  {
    id: "personal",
    name: "个人保障",
    slug: "personal",
    description: "个人安全防护装备、培训与应急服务，让每个人都能保护好自己",
    icon: "ri-shield-user-line",
  },
];

export const getArticlesByCategory = (categoryId: string) => {
  return articles.filter((a) => a.category === categoryId);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};